import { makeAction } from '@va/store';
import * as Types from './types';

/** @deprecated */
export const sendMetaSiteId = makeAction(Types.SEND_META_SITE_ID_REQUEST, 'metaSiteId');
/** @deprecated */
export const sendMetaSiteIdFailed = makeAction(Types.SEND_META_SITE_ID_FAILED, 'error');

export const activateDirectAccess = makeAction(Types.ACTIVATE_DIRECT_ACCESS_REQUEST, 'email');
export const activateDirectAccessSucceeded = makeAction(Types.ACTIVATE_DIRECT_ACCESS_SUCCEEDED, 'data');
export const activateDirectAccessFailed = makeAction(Types.ACTIVATE_DIRECT_ACCESS_FAILED, 'error');
